import { inject } from '@angular/core';
import { CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { PanoDurumService } from '@uygulamalar/hmi-pano/services/pano-durum.service';

const HMI_PANO_PREFIX = '/hmi-pano/';
const HMI_PANO_PREFIX_DECODED = '/hmi-pano/';

/**
 * Kart takılıyken personel sayfasından geri tuşu ile saçma route'lara
 * (yukleniyor, bosta, yetkisiz) gidilmesini engeller.
 *
 * HMI dışına (admin panel, paylaşım vs.) çıkışa izin verir - kullanıcı
 * bilinçli olarak üst menüden başka sayfaya gidebilir.
 */
export const kartAktifGuard: CanDeactivateFn<any> = (
  _component, _currentRoute, _currentState, nextState?: RouterStateSnapshot
) => {
  const durum = inject(PanoDurumService);

  // Kart takılı değilse her yere gidebilir
  if (!durum.sonPersonel()) return true;

  const hedef = nextState?.url || '';

  // HMI dışına çıkış → izin ver (admin panel, paylaşım vs.)
  const hmiIci = hedef.startsWith(HMI_PANO_PREFIX) || hedef.startsWith(HMI_PANO_PREFIX_DECODED);
  if (!hmiIci) return true;

  // HMI içi - personel alt route'larına izin ver
  if (hedef.includes('/personel')) return true;

  // Kart takılıyken bosta/yukleniyor/yetkisiz gibi route'lara gidişi engelle
  return false;
};
